import $ from 'jquery';
import Backbone from 'backbone';
import '@/vendor/jquery.tabSlideOut';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';

library.add(faPlus);
library.add(faXmark);
dom.watch()

export default Backbone.View.extend({

  initialize: function() {
    this.embed_width_field = this.$el.find("input#width");
    this.embed_auto_width = this.$el.find('input#auto-width');
    this.embed_include_description = this.$el.find('input#description');
    this.render();
  },

  events: {
    "keyup input#width" : "generate_embed_code",
    "change input#description" : "generate_embed_code",
    "change input#auto-width" : "generate_embed_code",
    "click .embed-tab-handle": "generate_embed_code"
  },

  defaultOptions: {
    width: "600"
  },

  render: function() {
    //slide-out tabs
    this.$el.tabSlideOut({
      tabHandle: '.embed-tab-handle',  //class of the element that will become your tab
      tabLocation: 'right', //where tab lives, top, right, bottom, or left
      offset: '60px',
      action: 'click',  //options: 'click' or 'hover', action to trigger animation
      onLoadSlideOut: false
    });

    this.generate_share_embed_text();
    this.activatePrintTab();
  },

  activatePrintTab: function () {
    // this is what happens when you use a fancy
    // popup library...
    $('#custom-print').on('click', function () {
      window.print()
    });
  },

  update_model: function(new_model) {
    if (new_model != undefined) {
      this.model = new_model;
    }

    this.generate_share_embed_text();
  },

  generate_share_embed_text: function() {
    this.generate_share_text();
    this.generate_embed_code();
  },

  generate_share_text: function() {
    this.$el.find("input#share-link").val("https://afdc.energy.gov/data/" + this.model.get("id"));
  },

  generate_embed_code: function() {
    var id = this.model.get("id");
    var width = this.defaultOptions.width + 'px';
    var widgetUrl = "https://afdc.energy.gov/data/widgets/" + id;
    var height = $('#chartModal').height() + 38;

    if (this.embed_auto_width.prop("checked")) {
      this.embed_width_field.attr("disabled", "disabled");
      width = $('#chartModal').width() + 'px';
      $('.hidden-chart-description').width(width);
    }
    else {
      this.embed_width_field.removeAttr("disabled");
      width = parseInt(this.embed_width_field.val()) || this.defaultOptions.width;
      width += 'px';
      $('.hidden-chart-description').width(width);
    }

    if (this.embed_include_description.prop("checked")) {
      $('.hidden-chart-description p').show();
    } else {
      $('.hidden-chart-description p').hide();
      widgetUrl += "?chart_only=true";
    }

    // Subtract the visible chart description from the height, and add back in
    // the hidden chart description (which has been resized for the expected
    // width).
    height -= $('.chart-description').height();
    height += $('.hidden-chart-description').height();

    var embedCode = "<iframe style=\"width: " + width + "; height: " + height + "px;\" " +
      "src=\"" + widgetUrl + "\" " +
      "frameborder=\"0\" marginwidth=\"0\" marginheight=\"0\" " +
      "scrolling=\"no\">" +
      "</iframe>";

    this.$el.find("textarea#embed-code").text(embedCode);
  }
});
